'use client'
import { Input, InputProps } from '@nextui-org/input'

import { clsx } from 'clsx'

import { FC, forwardRef, LegacyRef } from 'react'

import { IClassName } from '@/app/shared/interfaces/common.interface'
import { styles } from '@/app/shared/ui/input/services'

// interface
interface IInput extends IClassName, Omit<InputProps, 'ref'> {
  ref?: LegacyRef<any>
  colorType?: 'success' | 'secondary'
}

const InputComponent: FC<Readonly<IInput>> = forwardRef(
  ({ className, colorType, ...props }, ref) => {
    return (
      <Input
        {...props}
        color={colorType ?? 'success'}
        classNames={{
          ...styles(colorType ?? 'success'),
        }}
        className={clsx(className)}
        variant={'underlined'}
        ref={ref}
      />
    )
  },
)

InputComponent.displayName = 'InputComponent'

export default InputComponent
